import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import i18n from '@/utils/i18n'

export async function getCompanyLeases (companyId) {
  try {
    const response = await HTTP.get(`leases/?tenantNo=${companyId}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, null, i18n.t('error.getAllCompanyLeases.system'))
    throw err
  }
}
